import classNames from 'classnames';
import './PromoInfo.scss';

export interface PromoInfoProps {
  /** top line of text */
  line1?: string;
  /** second line of text */
  line2?: string;
  /** alternative to line1 and line2 */
  children?: string;
  className?: string;
}

/**
 * PromoInfo - styled text component
 * @param line1 - top line of text
 * @param line2 - second line of text
 * @param children - alternative to line1 and line2
 * @param className - optional class
 */

export const PromoInfo: React.FC<PromoInfoProps> = ({ line1, line2, className, children }) => (
  <div
    className={classNames('vds-promo-info', children && 'vds-promo-info--line-clamp', className)}>
    {line1 && <div className="vds-promo-info__line1">{line1}</div>}
    {line2 && <div className="vds-promo-info__line2 vds-promo-info--line-clamp">{line2}</div>}
    {children}
  </div>
);
